import { toast } from "react-toastify";
import {
  AdministratorAPI,
  AnalyticsAPI,
  PublicApi,
} from "../constants/apiRoutes";
import { globalActions } from "../reducers/global";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";
import { CustomToast } from "../components/Reusable/CustomToast";
import { t } from "i18next";
import { checkAuth } from "./user";
import { isValidPromoQuoteFingerprint } from "../utils/subscriptionPromo";
import { normalizeSubscriptionStatus } from "../utils/subscriptionStatus";

export const fetchSliderList = (type, size = 4) => {
  return (dispatch) => {
    dispatch(globalActions.fetchClearSliderList());
    dispatch(globalActions.actionStart());
    return apiService
      .get(PublicApi.slider(type, size))
      .then((response) => {
        dispatch(globalActions.fetchSliderList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchVideosList = (type, size = 10) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.videos(type, size))
      .then((response) => {
        dispatch(globalActions.fetchVideosList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCategoryVideosList = (type) => {
  return (dispatch, getState) => {
    const { userData } = getState().userReducer;
    const isLoggedIn = !!userData?.firstName;
    const url = isLoggedIn
      ? PublicApi.categoryForm(type)
      : PublicApi.categoryFormPublic(type);
    return apiService
      .get(url)
      .then((response) => {
        dispatch(globalActions.fetchCategoryVideosList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCategorySearchVideosList = (type) => {
  return (dispatch, getState) => {
    const { userData } = getState().userReducer;
    const isLoggedIn = !!userData?.firstName;
    const url = isLoggedIn
      ? PublicApi.categorySearchForm(type)
      : PublicApi.categorySearchFormPublic(type);
    return apiService
      .get(url)
      .then((response) => {
        dispatch(globalActions.fetchCategorySearchVideosList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchVideoDetail = (id, navigate) => {
  return (dispatch, getState) => {
    const { userData } = getState().userReducer;
    const isLoggedIn = !!userData?.firstName;
    const url = isLoggedIn
      ? PublicApi.video(id)
      : PublicApi.videoPublicDetail(id);
    return apiService
      .get(url)
      .then((response) => {
        dispatch(globalActions.fetchVideoDetail(response.data));
      })
      .catch((err) => {
        if (err.response && err?.response?.data?.status === 404) {
          navigate("/");
          return;
        }

        handleError(err);
      });
  };
};

export const fetchVideosTypeList = (type, size = 10, id = "") => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.videos(type, size, id))
      .then((response) => {
        if (type == "MICRO") {
          dispatch(globalActions.fetchVideosListMicro(response.data));
        } else if (type == "MINI") {
          dispatch(globalActions.fetchVideosListMini(response.data));
        } else if (type == "MASTER") {
          dispatch(globalActions.fetchVideosListMaster(response.data));
        } else {
          dispatch(globalActions.fetchVideosList(response.data));
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchVideosSearchList = (attr) => {
  return (dispatch, getState) => {
    const { userData } = getState().userReducer;
    const isLoggedIn = !!userData?.firstName;
    const url = isLoggedIn
      ? PublicApi.videosSearch(attr)
      : PublicApi.videosSearchPublic(attr);
    return apiService
      .get(url)
      .then((response) => {
        dispatch(globalActions.fetchVideosList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchVideosGridSearchList = (attr) => {
  return (dispatch, getState) => {
    const { userData } = getState().userReducer;
    const isLoggedIn = !!userData?.firstName;
    const url = isLoggedIn
      ? PublicApi.courseVideos(attr)
      : PublicApi.courseVideosPublic(attr);
    return apiService
      .get(url)
      .then((response) => {
        dispatch(globalActions.fetchVideosList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchMasterkatVideos = (attr) => {
  return (dispatch, getState) => {
    const { userData } = getState().userReducer;
    const isLoggedIn = !!userData?.firstName;
    const url = isLoggedIn
      ? PublicApi.courseVideos(attr)
      : PublicApi.courseVideosPublic(attr);
    return apiService
      .get(url)
      .then((response) => {
        dispatch(globalActions.fetchVideosListMaster(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReelsList = (attr) => {
  return (dispatch) => {
    dispatch(globalActions.fetchClearReelsList());
    return apiService
      .get(PublicApi.reels(attr))
      .then((response) => {
        dispatch(globalActions.fetchReelsList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchSearchVideosList = (
  name,
  page = 0,
  size = 10,
  categories
) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.searchVideos(name, page, size, categories))
      .then((response) => {
        dispatch(globalActions.fetchSearchVideosList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchSearchChannelsList = (
  name,
  page = 0,
  size = 32,
  categories
) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.searchChannels(name, page, size, categories))
      .then((response) => {
        dispatch(globalActions.fetchSearchChannelsList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCartAdd = (data, openModal, hideModal = null) => {
  return (dispatch) => {
    return apiService
      .post(PublicApi.cartAdd(), data)
      .then((response) => {
        toast(
          <CustomToast
            type="success"
            title={t("success.success")}
            message={t("success.cartAdd.title")}
          />
        );

        openModal("cart");
        hideModal && hideModal();

        // dispatch(fetchCartInfo());
        dispatch(fetchCartSize());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCartRemove = (id) => {
  return (dispatch) => {
    return apiService
      .post(PublicApi.cartRemove(id))
      .then((response) => {
        dispatch(fetchCartInfo());
        dispatch(fetchCartSize());
        toast(
          <CustomToast
            type="success"
            title={t("success.success")}
            message={t("success.cartAdd.remove")}
          />
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCartInfo = () => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.cartInfo())
      .then((response) => {
        dispatch(globalActions.fetchCartList(response?.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCartSize = () => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.cartSize())
      .then((response) => {
        dispatch(globalActions.fetchCartSize(response?.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchBookmarkItem = (id) => {
  return (dispatch) => {
    return apiService
      .put(PublicApi.bookmarkAdd(id))
      .then((response) => {
        // dispatch(globalActions.fetchCartSize(response?.data));
        toast(
          <CustomToast
            type="success"
            title={t("success.success")}
            message={t("success.bookmark.add")}
          />
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchBookmarkDeleteItem = (id) => {
  return (dispatch) => {
    return apiService
      .delete(PublicApi.bookmarkAdd(id))
      .then((response) => {
        // dispatch(globalActions.fetchCartSize(response?.data));
        toast(
          <CustomToast
            type="success"
            title={t("success.success")}
            message={t("success.bookmark.delete")}
          />
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchLikeItem = (id) => {
  return (dispatch) => {
    return apiService
      .put(PublicApi.likeAdd(id))
      .then((response) => {
        // dispatch(globalActions.fetchCartSize(response?.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchLikeDeleteItem = (id) => {
  return (dispatch) => {
    return apiService
      .delete(PublicApi.likeAdd(id))
      .then((response) => {
        // dispatch(globalActions.fetchCartSize(response?.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCourseDetail = (id) => {
  return (dispatch, getState) => {
    dispatch(globalActions.fetchClearCourseDetail());
    const { userData } = getState().userReducer;
    const isLoggedIn = !!userData?.firstName;
    const url = isLoggedIn
      ? PublicApi.course(id)
      : PublicApi.coursePublic(id);
    return apiService
      .get(url)
      .then((response) => {
        dispatch(globalActions.fetchCourseDetail(response?.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchBookmarkList = (page, size) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.bookmarkList(page, size))
      .then((response) => {
        dispatch(globalActions.fetchBookmarkList(response?.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchVideoMasterDetail = (id, navigate) => {
  return (dispatch, getState) => {
    dispatch(globalActions.fetchClearVideoMasterDetail());
    const { userData } = getState().userReducer;
    const isLoggedIn = !!userData?.firstName;
    const url = isLoggedIn
      ? PublicApi.videoMaster(id)
      : PublicApi.videoMasterPublicDetail(id);
    return apiService
      .get(url)
      .then((response) => {
        dispatch(globalActions.fetchVideoMasterDetail(response.data));
      })
      .catch((err) => {
        if (err.response && err?.response?.data?.status === 404) {
          navigate("/");
          return;
        }

        handleError(err);
      });
  };
};

export const fetchCartFinish = (navigate, hideModal) => {
  return (dispatch) => {
    return apiService
      .post(PublicApi.finishCart())
      .then((response) => {
        // console.log(response.data, "response");
        return response.data;
      })
      .catch((err) => {
        hideModal();
        navigate("/cart-error");
        handleError(err);
      });
  };
};

export const fetchContact = (data, handleReset) => {
  return (dispatch) => {
    const endpoint =
      data.type === "CONTACT_EDUCATOR"
        ? PublicApi.contactEducator()
        : PublicApi.contact();

    return apiService
      .post(endpoint, data)
      .then(() => {
        toast(
          <CustomToast
            type="success"
            title={t("success.success")}
            message={t("success.contact")}
          />
        );
        handleReset && handleReset();
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchJwPlayers = () => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.JwPlayers())
      .then((response) => {
        // dispatch(globalActions.fetchPublicJwPlayers(response.data));
        return response.data;
      })
      .catch((err) => handleError(err));
  };
};

export const fetchJwtToken = (videoId) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.videoJwt(videoId))
      .then((response) => {
        // dispatch(globalActions.fetchPublicJwPlayers(response.data));
        return response.data;
      })
      .catch((err) => handleError(err));
  };
};

export const fetchReceiptList = (page, size) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.receiptList(page, size))
      .then((response) => {
        dispatch(globalActions.fetchReceiptList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReceiptDetail = (id) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.receiptDetail(id))
      .then((response) => {
        dispatch(globalActions.fetchReceiptDetail(response?.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReelLikeItem = (id) => {
  return (dispatch) => {
    return apiService
      .put(PublicApi.reelLikeAdd(id))
      .then((response) => {
        // dispatch(globalActions.fetchCartSize(response?.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReelLikeDeleteItem = (id) => {
  return (dispatch) => {
    return apiService
      .delete(PublicApi.reelLikeAdd(id))
      .then((response) => {
        // dispatch(globalActions.fetchCartSize(response?.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchVideoAnalytics = (page = 0, size = 100, data) => {
  return (dispatch) => {
    dispatch(globalActions.actionStart());
    return apiService
      .post(AnalyticsAPI.videoStats(page, size), data)
      .then((response) => {
        dispatch(globalActions.fetchVideoAnalytics(response.data));
        // return response.data;
      })
      .catch((err) => handleError(err));
  };
};

export const fetchVideoAnalyticsPublic = (page = 0, size = 100, data) => {
  return (dispatch) => {
    dispatch(globalActions.actionStart());
    return apiService
      .post(AnalyticsAPI.videoPublicStats(page, size), data)
      .then((response) => {
        dispatch(globalActions.fetchVideoAnalyticsPublic(response.data));
        // return response.data;
      })
      .catch((err) => handleError(err));
  };
};

export const fetchSubscription = (page, size) => {
  return (dispatch) => {
    return apiService
      .get(AdministratorAPI.subscription(page, size))
      .then((response) => {
        dispatch(globalActions.fetchSubscriptionList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchStatisticBookmarkLike = (page, size) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.statsLikeBookmark(page, size))
      .then((response) => {
        dispatch(globalActions.fetchStatisticBookmarkLike(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchStatisticCountLike = (page, size) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.statsCountLike(page, size))
      .then((response) => {
        dispatch(globalActions.fetchStatisticCountLike(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
export const fetchStatisticCountBookmark = (page, size) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.statsCountBookmark(page, size))
      .then((response) => {
        dispatch(globalActions.fetchStatisticCountBookmark(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
export const fetchTotalSales = () => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.totalSales())
      .then((response) => {
        dispatch(globalActions.fetchTotalSales(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
export const fetchTotalRevenue = () => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.totalRevenue())
      .then((response) => {
        dispatch(globalActions.fetchTotalRevenue(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
export const fetchMontlyRevenue = (year = 2025) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.montlyRevenue(year))
      .then((response) => {
        dispatch(globalActions.fetchMontlyRevenue(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
export const fetchMontlySales = (year = 2025) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.montlySales(year))
      .then((response) => {
        dispatch(globalActions.fetchMontlySales(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchMontlySalesDetail = (year, month) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.montlySalesDetail(year, month))
      .then((response) => {
        dispatch(globalActions.fetchMontlySalesDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchTotalSalesDetail = (year, month) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.totalSalesDetail(year, month))
      .then((response) => {
        dispatch(globalActions.fetchTotalSalesDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeviceList = () => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.device())
      .then((response) => {
        dispatch(globalActions.fetchDeviceList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReelStats = (id) => {
  return (dispatch) => {
    return apiService
      .post(PublicApi.reelStats(id))
      .then((response) => {
        // dispatch(globalActions.fetchDeviceList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchPageContent = (type) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.content(type))
      .then((response) => {
        dispatch(globalActions.fetchPageContent(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchBestLike = (type) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.bestLike(type))
      .then((response) => {
        dispatch(globalActions.fetchBestLike(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchBestBookmark = (type) => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.bestBookmark(type))
      .then((response) => {
        dispatch(globalActions.fetchBestBookmark(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchRemoveDevice = (id) => {
  return (dispatch) => {
    return apiService
      .delete(PublicApi.deviceRemove(id))
      .then((response) => {
        dispatch(checkAuth());
        dispatch(fetchDeviceList());

        toast(
          <CustomToast
            type="success"
            title={t("device.title")}
            message={t("device.removeSuccess")}
          />
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchSubscriptionEarnings = () => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.subscriptionEarnings())
      .then((response) => {
        dispatch(globalActions.fetchSubscriptionEarnings(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchSubscriptionAnalyticsProfile = (startDate, endDate, options) => {
  return (dispatch) => {
    dispatch(globalActions.fetchSubscriptionAnalyticsProfileStart());
    return apiService
      .get(PublicApi.subscriptionAnalyticsProfile(startDate, endDate, options))
      .then((response) => {
        dispatch(globalActions.fetchSubscriptionAnalyticsProfile(response.data));
      })
      .catch((err) => {
        dispatch(globalActions.fetchSubscriptionAnalyticsProfileFailure());
        handleError(err);
      });
  };
};

export const fetchMySubscription = () => {
  return (dispatch, getState) => {
    return apiService
      .get(PublicApi.subscriptionMy())
      .then((response) => {
        const subscription = normalizeSubscriptionStatus(response.data);
        const newStatus = subscription?.status;
        const userId = getState().userReducer?.userData?.id;
        const storageKey = userId
          ? `lastSubscriptionStatus_${userId}`
          : "lastSubscriptionStatus";
        const lastStatus = localStorage.getItem(storageKey);

        if (lastStatus && newStatus && lastStatus !== newStatus) {
          let toastKey = null;
          if (newStatus === "ACTIVE" && lastStatus === "PENDING") {
            toastKey = "subscription.toast.renewed";
          } else if (newStatus === "EXPIRED" && lastStatus === "ACTIVE") {
            toastKey = "subscription.toast.expired";
          } else if (
            newStatus === "CANCELLED" &&
            lastStatus === "ACTIVE"
          ) {
            toastKey = "subscription.toast.cancelled";
          }

          if (toastKey) {
            const isPositive = newStatus === "ACTIVE";
            toast(
              <CustomToast
                type={isPositive ? "success" : "warning"}
                title={t(isPositive ? "success.success" : "error.error")}
                message={t(toastKey)}
              />
            );
          }
        }

        if (newStatus) {
          localStorage.setItem(storageKey, newStatus);
        }

        dispatch(globalActions.fetchMySubscription(subscription));
        return subscription;
      })
      .catch((err) => {
        dispatch(globalActions.clearMySubscription());
        return null;
      });
  };
};

export const fetchMyPayments = () => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.subscriptionPayments())
      .then((response) => {
        dispatch(globalActions.fetchMyPayments(response.data));
        return response.data;
      })
      .catch((err) => {
        handleError(err);
        return null;
      });
  };
};

export const fetchBestPlays = () => {
  return (dispatch) => {
    return apiService
      .get(PublicApi.bestPlays())
      .then((response) => {
        dispatch(globalActions.fetchBestPlays(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchSubscribe = (
  autoRenewConsent,
  promoCode = "",
  {
    suppressErrorToast = false,
    quoteFingerprint = null,
    quotedInitialAmount = null,
    checkoutInstructionVersion = null,
  } = {}
) => {
  return (dispatch) => {
    const payload = { autoRenewConsent };

    if (promoCode) {
      payload.promoCode = promoCode;

      if (isValidPromoQuoteFingerprint(quoteFingerprint)) {
        payload.quoteFingerprint = quoteFingerprint;
      }
      if (Number.isInteger(quotedInitialAmount) && quotedInitialAmount >= 0) {
        payload.quotedInitialAmount = quotedInitialAmount;
      }
      if (
        Number.isInteger(checkoutInstructionVersion) &&
        checkoutInstructionVersion > 0
      ) {
        payload.checkoutInstructionVersion = checkoutInstructionVersion;
      }
    }

    return apiService
      .post(PublicApi.subscriptionSubscribe(), payload)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (!suppressErrorToast) {
          handleError(err);
        }
        throw err;
      });
  };
};

export const fetchSubscriptionPromoQuote = (
  code,
  { authenticated = false, email = "" } = {}
) => {
  return () => {
    const payload = { code };
    const normalizedEmail = String(email || "").trim();

    if (!authenticated && normalizedEmail) {
      payload.email = normalizedEmail;
    }

    return apiService
      .post(
        authenticated
          ? PublicApi.subscriptionPromoQuoteAuthenticated()
          : PublicApi.subscriptionPromoQuote(),
        payload
      )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw err;
      });
  };
};

export const fetchUpdatePaymentMethod = () => {
  return () => {
    return apiService
      .post(PublicApi.subscriptionUpdatePaymentMethod())
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        handleError(err);
        throw err;
      });
  };
};

export const fetchSubscriptionPurchaseComplete = (orderId, trackingToken) => {
  return () => {
    if (!orderId) {
      return Promise.resolve(null);
    }

    if (trackingToken) {
      return apiService
        .post(PublicApi.subscriptionPurchaseCompletePublic(), {
          orderId,
          trackingToken,
        })
        .then((response) => response?.data ?? null);
    }

    return apiService
      .get(PublicApi.subscriptionPurchaseComplete(orderId))
      .then((response) => response?.data ?? null);
  };
};

export const fetchCancelRenewal = (payload = {}) => {
  return (dispatch) => {
    return apiService
      .post(PublicApi.subscriptionCancelRenewal(), payload)
      .then((response) => {
        toast(
          <CustomToast
            type="success"
            title={t("success.success")}
            message={t("subscription.cancelSuccess")}
          />
        );
        return dispatch(fetchMySubscription());
      })
      .catch((err) => {
        handleError(err);
        throw err;
      });
  };
};

export const fetchReactivateRenewal = () => {
  return (dispatch) => {
    return apiService
      .post(PublicApi.subscriptionReactivate())
      .then((response) => {
        toast(
          <CustomToast
            type="success"
            title={t("success.success")}
            message={t("subscription.reactivateSuccess")}
          />
        );
        dispatch(fetchMySubscription());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
